import { makeStyles } from '@material-ui/core/styles';
import { ICheckoutTheme } from 'src/common/theme/ICheckoutTheme';

export type AccessoriesClasses =
  | 'root'
  | 'image'
  | 'container'
  | 'checkIcon'
  | 'buttonContainer'
  | 'button'
  | 'primaryButton'
  | 'textContent'
  | 'title'
  | 'grid'
  | 'header'
  | 'primaryButtonCaption'
  | 'secondaryButtonCaption'
  | 'continueButtonContainer'
  | 'description'
  | 'itemsWrapper'
  | 'item';

const accessoriesStyles = makeStyles<ICheckoutTheme, AccessoriesClasses>(
  ({ spacing, breakpoints, palette }) => ({
    root: {
      margin: `${spacing(2)} 0`,
    },
    grid: {
      margin: '10px 0',
      flexDirection: 'row-reverse',
      [breakpoints.down('sm')]: {
        margin: 0,
      },
    },
    image: {
      maxWidth: '100%',
    },
    container: {
      display: 'flex',
      padding: `0 ${spacing(1)}`,
      flexDirection: 'column',
    },
    checkIcon: {
      color: 'green',
      marginRight: spacing(0.5),
    },
    title: {
      margin: `${spacing(1)} 0`,
      display: 'flex',
      alignItems: 'center',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    button: {
      marginBottom: spacing(1),
      boxShadow: 'none',
      textDecoration: 'underline',
      textDecorationSkipInk: 'none',
    },
    primaryButton: {},
    primaryButtonCaption: {
      color: palette.common.white,
    },
    secondaryButtonCaption: {
      color: palette.primary.main,
    },
    header: {
      marginLeft: spacing(3),
    },
    textContent: {
      marginBottom: spacing(2),
    },
    continueButtonContainer: {
      paddingTop: 20,
    },
    description: {
      display: 'flex',
      marginBottom: '30px',
      justifyContent: 'center',
      textAlign: 'center',
    },
    itemsWrapper: {
      justifyContent: 'center',
    },
    item: {
      display: 'none',
      margin: '1rem',
    },
  }),
  { name: 'Checkout4_Accesories' },
);

export default accessoriesStyles;
